import { Link } from "react-router-dom";
import { SigilMark } from "../components/Sigil";

export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen bg-ink flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="text-gold/40">
        <SigilMark className="w-24 h-24" />
      </div>
      <h1 className="font-serif text-3xl text-parchment mt-10">The Circle Remains Open</h1>
      <p className="text-parchment-muted mt-5 max-w-md text-sm leading-relaxed">
        No tribute was taken. Whenever you are ready to commence the working, the
        portal awaits your return.
      </p>
      <Link
        to="/"
        data-testid="payment-cancel-home-link"
        className="mt-12 bg-gold text-ink text-xs uppercase tracking-[0.2em] font-semibold rounded-full px-8 py-4 hover:bg-amber transition-colors"
      >
        Return to the Sanctum
      </Link>
    </div>
  );
}
